import React from 'react';

/**
 * Bazinio lygio žaidimų layoutas.
 * Naudojamas Quiz tipo ar kitiems žaidimams, kur natūralus scrollinimas yra priimtinas.
 */
const GameLayout = ({ 
  children, 
  title, 
  score, 
  timeSpent, 
  onExit, 
  headerExtra 
}) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col overscroll-none">
      {/* Universalus HUD / Header */}
      <div className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b-4 border-slate-100 px-4 py-3 md:px-8 md:py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          <button
            onClick={onExit}
            className="premium-button-3d px-4 py-2 bg-white text-slate-600 rounded-2xl font-black border-slate-200"
          >
            <span className="hidden md:inline">← Išeiti</span>
            <span className="md:hidden">✕</span>
          </button>

          <div className="text-center flex-1 min-w-0">
            <h2 className="text-lg md:text-2xl font-black text-slate-800 truncate tracking-tight uppercase">
              {title}
            </h2>
            {headerExtra}
          </div>

          <div className="flex gap-2 md:gap-4 items-center">
            <div className="bg-gradient-to-br from-yellow-400 to-orange-500 px-4 py-2 rounded-2xl shadow-lg border-b-4 border-orange-700">
              <span className="text-white font-black text-lg md:text-2xl">⭐ {score}</span>
            </div>
            <div className="bg-white px-4 py-2 rounded-2xl shadow-md border-b-4 border-slate-100 font-black text-slate-600 flex items-center gap-2">
              <span className="text-xl">⏱️</span>
              <span className="text-lg md:text-2xl tabular-nums">{formatTime(timeSpent)}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Turinys - leidžia natūralų scrollą jei tekstas ilgas */}
      <main className="flex-1 w-full max-w-7xl mx-auto p-4 md:p-8 animate-slide-up">
        {children}
      </main>
    </div>
  );
};

export default GameLayout;
